"use strict";

var _classCallCheck = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _fileSaver = _interopRequireDefault(require("file-saver"));

var _FDSMail = _interopRequireDefault(require("../FDS-Mail.js"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Copyright 2019 The FairDataSociety Authors
// This file is part of the FairDataSociety library.
//
// The FairDataSociety library is free software: you can redistribute it and/or modify
// it under the terms of the GNU Lesser General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// The FairDataSociety library is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
// GNU Lesser General Public License for more details.
//
// You should have received a copy of the GNU Lesser General Public License
// along with the FairDataSociety library. If not, see <http://www.gnu.org/licenses/>.


var Message =
/*#__PURE__*/
function () {
  function Message(attrs, config, account) {
    _classCallCheck(this, Message);

    if (attrs.to === undefined) throw new Error('to must be defined');
    if (attrs.from === undefined) throw new Error('from must be defined');
    if (attrs.hash === undefined) throw new Error('hash must be defined');
    this.to = attrs.to;
    this.from = attrs.from;
    this.hash = attrs.hash;
    this.account = account;
    this.Mail = this.account.Mail;
    return this;
  }

  _createClass(Message, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        to: this.to,
        from: this.from,
        hash: this.hash.toJSON()
      };
    }
    /**
      * get file for this message
      * @param {any} decryptProgressCallback callback
      * @param {any} downloadProgressCallback callback
      * @returns {File} file 
     */

  }, {
    key: "getFile",
    value: function getFile() {
      var decryptProgressCallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : console.log;
      var downloadProgressCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : console.log;

      if (this.to === this.account.subdomain) {
        return this.Mail.receive(this.account, this, decryptProgressCallback, downloadProgressCallback);
      } else if (this.from === this.account.subdomain) {
        return this.Mail.retrieveSent(this.account, this, decryptProgressCallback, downloadProgressCallback);
      } else {
        throw Error('there was a problem...');
      }
    }
  }, {
    key: "saveAs",
    value: function saveAs() {
      var decryptProgressCallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : console.log;
      var downloadProgressCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : console.log;
      return this.getFile(decryptProgressCallback = console.log, downloadProgressCallback = console.log).then(function (file) {
        return (0, _fileSaver.default)(file);
      });
    }
  }]);

  return Message;
}();

module.exports = Message;